import { render } from "./SensorAlertSetting.vue?vue&type=template&id=c4eb7110"
import script from "./SensorAlertSetting.vue?vue&type=script&lang=js"
export * from "./SensorAlertSetting.vue?vue&type=script&lang=js"

import "./SensorAlertSetting.vue?vue&type=style&index=0&id=c4eb7110&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__